import $ from "jquery";
global.$ = $;
global.jQuery = $;

require("@rails/ujs").start();
require("@rails/activestorage").start();

require("../src/site/app");
